<template>
  <div class="centerDetails">
    <banner img="../assets/img/bgtop.jpg" title="产品详情"/>
	<div class="content">
		<el-row>
			<el-col :span="12">
				<img style="width: 100%;" :src="newsIdList.cover" />
			</el-col>
			<el-col :span="12">
				<div class="text">
					<p class="title">{{newsIdList.title}}</p>
					<p class="remark">{{newsIdList.remark}}</p>
				</div>
			</el-col>
		</el-row>
		<el-tabs type="card" style="margin-top: 20px;">
			<el-tab-pane label="产品详情">
				<div id="editor-content-view" class="editor-content-view" v-html="newsIdList.content"></div>
			</el-tab-pane>
		</el-tabs>
	</div>
<!--    <div class="NewsDetails-product">
      <div class="NewsDetails-product-content">
        <p class="product-title">{{newsIdList.title}}</p>
        <p class="product-time">{{newsIdList.createTime}}</p>
        <p style="min-width: 1240px;" class="ql-editor" v-html="newsIdList.content"></p>
      </div>
    </div> -->
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "centerDetails",
  components: {
    Banner
  },
  data() {
    return {
      pid: 0,
      newsIdList: {}
    };
  },
  created() {
    this.pid = this.$route.params.id;
    // window.console.log(this.pid);
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      // this.$http.post('/oa/newcms/article/getDataByid',{id:this.pid})
      // .then(response => {
      // 	this.newsIdList = response.data.result
      // 	console.log(this.newsIdList)
      // })
      // .catch(error=> {

      // })
	  const {data : { result }} = await this.$http({
	  	method: 'post',
	  	url: this.$baseURL + '/oa/newcmsArticle/getData',
	  	data: {
	  		id: this.pid
	  	}
	  })
	  this.newsIdList = result
    }
  }
};
</script>
<style lang="scss" scoped>
.centerDetails {
  width: 100%;
  height: 100%;

  .content{
	  width: 1240px;
	  margin: auto;
	  padding: 20px;

	  .text{
		padding: 20px;
		.title{
			font-size: 25px;
		}
		.remark{
			margin-top: 10px;
		}
	  }
  }

  //overflow: hidden;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    &-content {
      width: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 20px 0;
      img {
        width: 100%;
        //height: 500px;
      }
      .product-title {
		width: 100%;
		text-align: center;
		font-size: 25px;
        color: #e13834;
        padding: 15px 0;
      }
	  .product-time{
	      width: 100%;
		  margin-bottom: 10px;
		  text-align: right;
	  }
      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
      }
    }
  }
}
</style>
